/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * {Document Title}
 * {Description}
 */

( function( window, $ ) {
	'use strict';
	var document = window.document;

    var sidebar_fixed = {

        init: function() {

            $(document).on('_page_loaded load', js_sidebar_fix );

            function js_sidebar_fix(){
                if($('#js-sidebar-fix').width() > 0){

                    var stickyOffset = $('#js-sidebar-fix').offset().top;
                    
                    $(window).scroll(function(){
                        var sticky = $('#js-sidebar-fix'),
                        scroll = $(window).scrollTop();

                        if($(window).width() <= 768){
                            sticky.removeClass('sticky');
                            return;
                        }

                        if (scroll >= stickyOffset) sticky.addClass('sticky');
                        else sticky.removeClass('sticky');
                    });

                    var stickyOffsetFooter = $('#js-footer-fix').offset().top;

                    $(window).scroll(function(){
                        var sticky = $('#js-footer-fix'),
                        scroll = $(window).scrollTop();

                        if (scroll >= stickyOffsetFooter ) sticky.addClass('fixed');
                        else sticky.removeClass('fixed');
                    });

                }
            }

            js_sidebar_fix();

            $(document).on('click', '.btn-show-sidebar', function(){
                $('#page').toggleClass('expand_news');
            });

        }

    };

    $(document).ready(function(){
        sidebar_fixed.init();
    });

} )(window,jQuery);
